import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { fetchApartments } from '../../actions/apartmentsActions'
import useOnMount from '../../hooks/useOnMount'
import { getType } from '../../helpers/linkResolver/linkResolver'

const withHomePageApartments = (Component) => (props) => {
  const { maxApts, apartmentsReducer, dispatch } = props
  const { apartments, apartmentsLoading, apartmentsError } = apartmentsReducer

  useOnMount(() => {
    if (apartments === null && !apartmentsLoading && !apartmentsError)
      dispatch(fetchApartments(getType(window.location.pathname)))
  })

  return (
    <Component
      title="Lausar íbúðir"
      loading={apartmentsLoading || apartments === null}
      error={apartmentsError}
      apartments={apartments}
			maxApts={maxApts}
    />
  )
}

const mapStateToProps = ({ apartmentsReducer }) => ({
  apartmentsReducer,
})

const composedPageWrapper = compose(
  connect(
    mapStateToProps,
    null,
  ),
  withHomePageApartments,
)

export default composedPageWrapper
